import Collection from '@/components/Collection'
import CreateForm from '@/pages/tld/CreateForm'
import ViewTLD from '@/pages/tld/Detail'
import EditTLD from '@/pages/tld/Update'
import access from "../access";

export default {

  'tld.collection': {
    path: '/admin/tlds',
    name: 'tld.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listTLDs",
      entity: "tld",
      cols: [
        { label: "TLD", field: "tld", sort: "tld" },
        { label: "Price", field: "price", sort: "price" },
        { label: "Allow IDN", field: "idn_allowed", sort: "idn_allowed" },
        { label: "Registrant CC", field: "registrant_cc", flag: true, sort: "registrant_cc" },
        { label: "Auto-renew period", field: "auto_renew_period", sort: "auto_renew_period" },
        { label: "RGP period", field: "rgp_period", sort: "rgp_period" },
        { label: "Pending delete period", field: "pending_delete_period", sort: "pending_delete_period" },
        { label: "Expiration policy", field: "expiration_policy" },
      ],
      actions: (row) => {
        return [
          { name: "tld.view", label: "view", icon: "eye", params: {tld: row.tld} },
          { name: "tld.update", label: "edit", icon: "pencil2", params: {tld: row.tld} },
        ];
      }
    },
    meta: {
      access: access.admin,
      title: "Top-level domain list",
      side_menu: { label: "TLDs",  icon: "earth" },
      local_actions: [
        { name: "tld.create", label: "Create TLD", color: "success", icon: "plus" }
      ]
    },
  },

  'tld.create': {
    path: '/admin/tlds/create',
    name: 'tld.create',
    component: CreateForm,
    meta: {
      access: access.admin,
      title: "Create new top-level domain"
    },
  },

  'tld.view': {
    path: '/admin/tlds/view/:tld',
    name: 'tld.view',
    component: ViewTLD,
    props: true,
    meta: {
      access: access.admin,
      title: "TLD details",
      local_tasks: [
        { name: "tld.view", label: "View"},
        { name: "tld.update", label: "Edit"}
      ]
    },
  },

  'tld.update': {
    path: '/admin/tlds/edit/:tld',
    name: 'tld.update',
    component: EditTLD,
    props: true,
    meta: {
      access: access.admin,
      title: "Update TLD details",
      local_tasks: [
        { name: "tld.view", label: "View"},
        { name: "tld.update", label: "Edit"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/tld.js